export type ScreenshotOptions = {
  output?: "file" | "base64" | "dataUri";
};
